import React from 'react';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { ClientAccessSettingsProps } from '../../../../ClientAccess.types';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { Separator } from '../../../../../CommonComponents/OPL/Separator/Separator';
import { DashboardFeatureId } from '../../../../../AdviserArea/AdviserArea.types';

export const Other: React.FC<ClientAccessSettingsProps> = ({
  linkAccountsAccess,
  creditMonitoringAccess,
  dataReconciliationAccess,
  isProBonoClient,
  showCreditMonitoring,
  showDataAggregation,
  showDataReconciliation,
  showProBono,
  canAddManualAccount,
  displayAddManualAccountToggle,
  allowMobileAppPushNotifications,
  defaultDocumentUploadMobilePushNotifications,
  displayMobileAppPushNotificationsSection,
  onChange,
  hasDocumentVaultFirm,
  dashboardAccess,
}) => {
  if (
    !(
      showDataAggregation ||
      displayAddManualAccountToggle ||
      showCreditMonitoring ||
      showDataReconciliation ||
      showProBono
    )
  ) {
    return null;
  }

  const hasDocumentVaultAccess = dashboardAccess?.includes(DashboardFeatureId.DocumentVault);

  return (
    <>
      <Separator />

      <section>
        <Text fontWeight={500} my="16">
          Other
        </Text>

        <Box pl="24">
          {showDataAggregation && (
            <Toggle
              variant="setting"
              checked={linkAccountsAccess}
              onChange={evt => onChange({ linkAccountsAccess: evt.target.checked })}
              my="16"
            >
              Link Accounts
            </Toggle>
          )}

          {displayAddManualAccountToggle && (
            <Toggle
              variant="setting"
              checked={canAddManualAccount}
              onChange={evt => onChange({ canAddManualAccount: evt.target.checked })}
              my="16"
            >
              Manual Accounts
            </Toggle>
          )}

          {showCreditMonitoring && (
            <Toggle
              variant="setting"
              checked={creditMonitoringAccess}
              onChange={evt => onChange({ creditMonitoringAccess: evt.target.checked })}
              my="16"
            >
              Credit Monitoring
            </Toggle>
          )}

          {showDataReconciliation && (
            <Toggle
              variant="setting"
              checked={dataReconciliationAccess}
              onChange={evt => onChange({ dataReconciliationAccess: evt.target.checked })}
              my="16"
            >
              Reconciled Held-Away Accounts
            </Toggle>
          )}

          {showProBono && (
            <Toggle
              variant="setting"
              checked={isProBonoClient}
              onChange={evt => onChange({ isProBonoClient: evt.target.checked })}
              my="16"
            >
              Pro Bono Client
            </Toggle>
          )}
        </Box>
      </section>

      {displayMobileAppPushNotificationsSection && (
        <>
          <Separator />

          <section>
            <Toggle
              variant="setting"
              checked={allowMobileAppPushNotifications}
              disabled={!hasDocumentVaultAccess}
              onChange={evt =>
                onChange({
                  allowMobileAppPushNotifications: evt.target.checked,
                  defaultDocumentUploadMobilePushNotifications: evt.target.checked,
                })
              }
              my="16"
            >
              Mobile App Notifications
            </Toggle>

            {hasDocumentVaultFirm && (
              <>
                <Text fontSize="small" color="neutral.500" mt={-12} mb="16">
                  Select the item(s) that the user will receive notifications
                </Text>

                <Box pl="24">
                  <Toggle
                    variant="setting"
                    checked={defaultDocumentUploadMobilePushNotifications}
                    disabled={!hasDocumentVaultAccess}
                    onChange={evt =>
                      onChange({
                        allowMobileAppPushNotifications: evt.target.checked,
                        defaultDocumentUploadMobilePushNotifications: evt.target.checked,
                      })
                    }
                    my="16"
                  >
                    Document Upload
                  </Toggle>
                </Box>
              </>
            )}
          </section>
        </>
      )}
    </>
  );
};
